//Hooks
import { get } from 'svelte/store';
//Formating
import { format } from 'svelte-i18n';
//Configs
import { devices_config } from '@devices/index';
//Types
import type { Device } from 'src/types/Device';

export type WebHookCondition = {
	title: string;
	index: number;
	value: string;
	label?: string;
	conditionEvent?: string;
};

export const getWebHookConditions = (type: string): WebHookCondition[] => {
	const $format = get(format);
	const isBoolean = /^(boolean|button)$/.test(type);
	const conditions = [
		{
			title: $format(isBoolean ? 'condition_is' : 'equal_to', {
				default: isBoolean ? 'is' : 'equal to',
			}),
			index: 0,
			value: '===',
		},
		{
			title: $format(isBoolean ? 'condition_is_not' : 'is_not_equal_to', {
				default: isBoolean ? 'is not' : 'not equal to',
			}),
			index: 1,
			value: '!==',
		},
	];
	if (/^(number)$/.test(type)) {
		return [
			...conditions,
			{
				title: $format(`operator_less_than`, { default: `less than` }),
				index: 2,
				value: '<',
			},
			{
				title: $format(`operator_more_than`, { default: `more than` }),
				index: 3,
				value: '>',
			},
		];
	}
	return conditions;
};

export const getTransformedWebHookConditions = (
	conditionEvent: string,
	label: string,
	startIndex: number,
): WebHookCondition[] => {
	const $format = get(format);
	return [
		{
			title: $format('transformed_value_equal_to', {
				default: 'custom expression value equal to',
			}),
			index: startIndex,
			value: `${conditionEvent} ===`,
			label,
		},
		{
			title: $format('transformed_value_is_not_equal_to', {
				default: 'custom expression value not equal to',
			}),
			index: startIndex + 1,
			value: `${conditionEvent} !==`,
			label,
		},
		{
			title: $format(`transformed_value_less_than`, {
				default: `custom expression value less than`,
			}),
			index: startIndex + 2,
			value: `${conditionEvent} <`,
			label,
		},
		{
			title: $format(`transformed_value_greater_than`, {
				default: `custom expression value greater than`,
			}),
			index: startIndex + 3,
			value: `${conditionEvent} >`,
			label,
		},
	];
};

export const emPhasesConditions = (event: string, device: Device): WebHookCondition[] => {
	const phase = devices_config[device.type]?.modes['emeter']?.phases || 3,
		$format = get(format),
		phases = [
			{
				title:
					$format('phase', {
						default: 'Phase',
					}) + ' A',
				value: '"a"',
				index: 0,
			},
			{
				title:
					$format('phase', {
						default: 'Phase',
					}) + ' B',
				value: '"b"',
				index: 1,
			},
			{
				title:
					$format('phase', {
						default: 'Phase',
					}) + ' C',
				value: '"c"',
				index: 2,
			},
		],
		difference = phases.length - phase;

	if (difference !== 0) {
		for (let i = 0; i < difference; i++) {
			phases.pop();
		}
	}
	if (event == 'em.current_change') {
		phases.push({
			title:
				$format('phase', {
					default: 'Phase',
				}) + ' N',
			value: '"n"',
			index: phases.length,
		});
	}
	return phases;
};

export const bthomeButtonsConditions = (btnCount: number): WebHookCondition[] => {
	const $format = get(format);
	const title = $format('input_type_button', {
		default: 'Button',
	});
	const buttons = [];
	for (let i = 0; i < btnCount; ++i) {
		buttons.push({
			title: title + ` (${i})`,
			value: i,
		});
	}
	return buttons;
};

export const clearQuotes = (value: string) => {
	return (value || '').replace(/(^(\\)?")|((\\)?"$)/g, '');
};
